import { useMutation } from 'react-query';

export default function useCreateProfileAndSignIn() {
  return useMutation(
    async (params: {
      firstName: string | undefined;
      lastName: string | undefined;
    }) => {
      const response = await fetch('/auth/signup/profile_for_hubspot', {
        method: 'POST',
        body: JSON.stringify({
          first_name: params.firstName,
          last_name: params.lastName,
          anonymous_id: window.analytics?.user?.()?.anonymousId?.(),
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();

        return {
          isSuccess: true,
          redirectPath: data.redirect_path,
        };
      } else {
        const data = await response.json();
        return { isSuccess: false, error: data };
      }
    },
  );
}
